// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"Y9-z"};